import { useState, useEffect } from 'react';
import './SplashScreen.css';

function SplashScreen({ onEnter }) {
	const [opening, setOpening] = useState(false);

	useEffect(() => {
		// Hide the Tawk.to chat widget while the disclaimer is showing.
		document.body.classList.add('splash-active');
		return () => {
			document.body.classList.remove('splash-active');
		};
	}, []);

	const handleEnter = () => {
		setOpening(true);
		// Match the CSS transition duration (0.8s) before unmounting.
		setTimeout(() => {
			onEnter();
		}, 800);
	};

	return (
		<div className={`splash-overlay${opening ? ' opening' : ''}`}>
			<div className="curtain curtain-left" />
			<div className="curtain curtain-right" />
			<div className="splash-glow" />

			<div className="splash-content">
				<span className="splash-eyebrow">Knowledge Plus</span>
				<h2 className="splash-title">Demo Notice</h2>
				<div className="splash-divider" />
				<p className="splash-text">
					This is a static deployment of a freelance project from 2021, published
					for demonstration / portfolio purposes only. The backend is offline, so
					forms, logins, and dynamic data are non-functional. This site has no
					affiliation with any live organization and represents no real, operating
					service.
				</p>
				<button className="splash-button" onClick={handleEnter}>
					Enter
				</button>
			</div>
		</div>
	);
}

export default SplashScreen;
